// extracted by mini-css-extract-plugin
export var shareIconBtn = "share-social-icons-module--share-icon-btn--778c0";
export var shareSocialList = "share-social-icons-module--share-social-list--a0d21";
export var socialEmail = "share-social-icons-module--social-email--5e108";